import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      border: '1px dashed #707070',
      borderRadius: '4px',
      maxWidth: '140px',
      margin: '10px',
      minHeight: '200px',
      backgroundColor: '#F5F5F5',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      padding: '20px 30px',
      '& svg': {
        width: '27px',
        height: '20px'
      },

      '@media (max-width:768px)': {
        maxWidth: '145px',
      }
    },
    text: {
      // border:'1px solid red',
      color: '#545456',
      fontSize: '12px',
      marginTop: '3px',
      overflowWrap: 'break-word'
    },
    downloadForm:{
      fontSize: '10px',
      letterSpacing: '0px',
      wordWrap: 'break-word',

      '& svg': {
        width: '18px',
        height: '17px'
      },
      '& p': {
        fontSize: '10px'
      }
    },
    textlayout: {
      marginTop: '10px',
      textAlign: 'center',
      width:'100%'
    },
    uploadfiledescription: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: '#545456',
      // // border: '2px solid red',
      margin: '2px 0 20px',
      textAlign: 'center',
      height: '30px'
    },
  }),
  { index: 1 },
)

export { useStyles }
